export default "__VITE_ASSET__9e1ecee8__"